import MEKRONLanding from "./MEKRONLanding";

function App() {
  return <MEKRONLanding />;
}

export default App;